/**
 * ████████╗ ██████╗ ██╗     ██╗███╗   ██╗ ██████╗
 * ╚══██╔══╝██╔═══██╗██║     ██║████╗  ██║██╔═══██╗
 *    ██║   ██║   ██║██║     ██║██╔██╗ ██║██║   ██║
 *    ██║   ██║   ██║██║     ██║██║╚██╗██║██║   ██║
 *    ██║   ╚██████╔╝███████╗██║██║ ╚████║╚██████╔╝
 *    ╚═╝    ╚═════╝ ╚══════╝╚═╝╚═╝  ╚═══╝ ╚═════╝
 *
 * (c) Copyright 2023-present Rakuten Kobo Inc. (https://www.kobo.com)
 */


export const ERROR_MISSING_ID = "MISSING_ID";


export const PUSH_TO_CLOUD_ERROR_DETAIL = {

  DEMO_TOKEN: {
    message: "No push 2 cloud with demo token",
    name: "Error"
  },

  [ERROR_MISSING_ID]: {
    guru: "there was no pubid to fetch a authorize for",
    isSilent: false,
    message: "This function is not available for this book",
    title: "Sorry"
  }
}
